module.exports = __webpack_public_path__ + "img/kw.f236070f.svg";